import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "@container tw-group tw-relative tw-flex tw-items-center tw-transition-all hover:dark:tw-bg-slate-900" }
const _hoisted_2 = { class: "tw-block tw-w-full tw-flex-1 tw-overflow-hidden tw-px-4" }
const _hoisted_3 = { class: "tw-truncate tw-text-sm @lg:tw-text-base" }
const _hoisted_4 = { class: "tw-max-w-xl tw-truncate tw-text-xs tw-text-slate-500" }
const _hoisted_5 = {
  key: 0,
  class: "tw-max-w-xl tw-truncate tw-text-xs tw-text-slate-500"
}
const _hoisted_6 = { class: "tw-flex-none tw-pr-3 @lg:tw-pt-0" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = ["data-testid"]
const _hoisted_9 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_StudioAvatar = _resolveComponent("StudioAvatar")!
  const _component_ExclamationTriangle = _resolveComponent("ExclamationTriangle")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass({
      'tw-py-2': true,
      'tw-cursor-pointer': _ctx.clickable,
      'hover:tw-bg-slate-50': !_ctx.isSelected
    }),
    "data-testid": "studio-person-list-item"
  }, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.showAvatar)
        ? (_openBlock(), _createBlock(_component_StudioAvatar, {
            key: 0,
            class: "tw-ml-3",
            name: _ctx.title,
            imageSrc: _ctx.imageSrc
          }, null, 8, ["name", "imageSrc"]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.title), 1),
        _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.subTitle), 1),
        (_ctx.subTitleSecondary)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.subTitleSecondary), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _renderSlot(_ctx.$slots, "right")
      ])
    ]),
    (_ctx.alerts.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.alerts, (alert) => {
            return (_openBlock(), _createElementBlock("div", {
              key: alert.key,
              "data-testid": alert.key,
              class: "tw-mx-2 tw-mt-2 tw-flex tw-items-center tw-rounded-lg tw-bg-yellow-100 tw-p-2 tw-px-4 tw-text-xs tw-text-yellow-700 hover:tw-cursor-auto",
              onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
            }, [
              _createVNode(_component_ExclamationTriangle, { class: "tw-mr-2 tw-h-4 tw-w-4" }),
              _createElementVNode("div", null, [
                _createTextVNode(_toDisplayString(alert.message) + " ", 1),
                (alert.helpDoc)
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 0,
                      innerHTML: alert.helpDoc
                    }, null, 8, _hoisted_9))
                  : _createCommentVNode("", true)
              ])
            ], 8, _hoisted_8))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ], 2))
}